import apiClient from './apiClient';
import { TableWord, TableGameAudit, Category } from '../types/tableGame';
import api from '../config/api';
import { logger } from '../utils/logger';

export class TableGameService {
  /**
   * Get a random word for table mode
   */
  static async getRandomWord(): Promise<string> {
    try {
      const response = await apiClient.get<TableWord>(`${api.endpoints.table}/random-word`);
      return response.data.word;
    } catch (error) {
      logger.error('Error fetching random word:', error);
      // Fallback words in case of error
      const fallbackWords = [
        'Pizza', 'Gato', 'Pelota', 'Árbol', 'Casa', 'Luna', 'Estrella', 
        'Montaña', 'Río', 'Flor', 'Libro', 'Silla', 'Mesa', 'Ventana'
      ];
      return fallbackWords[Math.floor(Math.random() * fallbackWords.length)];
    }
  }

  /**
   * Get all available categories
   */
  static async getCategories(): Promise<Category[]> {
    try {
      const response = await apiClient.get<Category[]>('/api/categories');
      return response.data;
    } catch (error) {
      logger.error('Error fetching categories:', error);
      return [];
    }
  }

  /**
   * Get a random word from a specific category
   */
  static async getRandomWordFromCategory(categoryId: number): Promise<string> {
    try {
      const response = await apiClient.get<{ character: string }>(
        `/api/categories/${categoryId}/random-character`
      );
      return response.data.character;
    } catch (error) {
      logger.error('Error fetching random word from category:', error);
      throw error;
    }
  }

  /**
   * Save table game audit (silently fails)
   */
  static async saveGameAudit(audit: Omit<TableGameAudit, 'createdAt'>): Promise<void> {
    try {
      await apiClient.post(`${api.endpoints.table}/audit`, {
        ...audit,
        createdAt: new Date().toISOString()
      });
    } catch (error) {
      // Silently fail as per requirements
      logger.debug('Audit save failed (expected behavior):', error);
    }
  }
}
